import { Wifi, Flame, Mountain, Car, ConciergeBell, UtensilsCrossed } from "lucide-react";

const AMENITIES = [
  { icon: Wifi, label: "Free Wi-Fi", note: "Stay connected across the property" },
  { icon: Flame, label: "Bonfire & BBQ", note: "Nightly fire, weekend grill" },
  { icon: Mountain, label: "Mountain Balconies", note: "Every room opens to a view" },
  { icon: Car, label: "On-site Parking", note: "Ample space for guest vehicles" },
  { icon: ConciergeBell, label: "Room Service", note: "Warm meals, delivered slow" },
  { icon: UtensilsCrossed, label: "Restaurant & Dining", note: "House kitchen, local produce" },
];

export default function Amenities() {
  return (
    <section
      id="amenities"
      data-testid="amenities-section"
      className="relative bg-[color:var(--sh-forest-deep)] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14 sh-reveal">
          <div>
            <div className="text-xs uppercase tracking-[0.35em] text-[color:var(--sh-amber)] mb-4">
              Amenities
            </div>
            <h2 className="sh-display text-[color:var(--sh-cream)] text-4xl sm:text-5xl lg:text-6xl font-medium max-w-3xl">
              Everything you need, nothing you don’t.
            </h2>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sh-reveal">
          {AMENITIES.map((a) => (
            <div
              key={a.label}
              data-testid={`amenity-${a.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="sh-card rounded-2xl p-6 flex items-start gap-5 group"
            >
              <div className="w-12 h-12 rounded-full border border-[color:var(--sh-line)] flex items-center justify-center shrink-0 group-hover:border-[color:var(--sh-amber)] transition">
                <a.icon size={20} strokeWidth={1.4} className="text-[color:var(--sh-amber)]" />
              </div>
              <div>
                <div className="sh-serif text-lg text-[color:var(--sh-cream)]">{a.label}</div>
                <div className="text-sm text-[color:var(--sh-cream-dim)] mt-1">{a.note}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
